import {
    ADDUPDATENOTIFICATIONCONFIGPARTNER_SUCCESS,
    ADDUPDATENOTIFICATIONCONFIGPARTNER_FAILED,
    RESET_ADDUPDATENOTIFICATIONCONFIGPARTNER,
    LOADING_ADDUPDATENOTIFICATIONCONFIGPARTNER,
    NETWORK_ERROR_ADDUPDATENOTIFICATIONCONFIGPARTNER
} from "../types/index";

const initialState = {
    isLoading: false,
    success: false,
    network: false,
    failed: false,
    data: {}
};

export default (state = initialState, action) => {
    switch (action.type) {
        case LOADING_ADDUPDATENOTIFICATIONCONFIGPARTNER:
            return {
                ...state,
                isLoading: true,
                success: false,
                failed: false,
                network: false,
                data: {}
            };
        case ADDUPDATENOTIFICATIONCONFIGPARTNER_FAILED:
            return {
                ...state,
                isLoading: false,
                success: false,
                failed: true,
                network: false,
                data: action.payload
            };
        case ADDUPDATENOTIFICATIONCONFIGPARTNER_SUCCESS:
            return {
                ...state,
                isLoading: false,
                success: true,
                failed: false,
                network: false,
                data: action.payload
            };
        case NETWORK_ERROR_ADDUPDATENOTIFICATIONCONFIGPARTNER:
            return {
                ...state,
                isLoading: false,
                success: false,
                failed: false,
                network: true,
                data: {}
            };
        case RESET_ADDUPDATENOTIFICATIONCONFIGPARTNER:
            return (state = initialState);
        default:
            return state;
    }
};
